import { AdditionalStructure } from '../commentary/DepreciatedCost/AdditionalStructure.tsx';
import { Condition } from '../commentary/DepreciatedCost/Condition.tsx';
import { ExternalDepreciation } from '../commentary/DepreciatedCost/ExternalDepreciation.tsx';
import { FunctionalDepreciation } from '../commentary/DepreciatedCost/FunctionalDepreciation.tsx';
import { MainDwelling } from '../commentary/DepreciatedCost/MainDwelling.tsx';
import { Quality } from '../commentary/DepreciatedCost/Quality.tsx';
import { MarketAdjustments } from '../commentary/MarketAdjustments/MarketAdjustments.tsx';
import { SiteExtraction } from '../commentary/SiteExtraction/SiteExtraction.tsx';
import { AllPairedCostAdjustmentSummaryTypes } from '../summaryV2/PairedCostAdjustmentSummary/types.ts';

export const AdjustmentsModalContent = ({
  adjType,
}: {
  adjType: AllPairedCostAdjustmentSummaryTypes;
}) => {
  switch (adjType) {
    case 'termsOfSale':
    case 'dateOfSale':
    case 'concessions':
      return <MarketAdjustments isModal />;
    case 'site':
    case 'locationView.location':
    case 'locationView.view':
    case 'site.size':
    case 'site.location':
    case 'site.view':
      return <SiteExtraction />;
    case 'quality':
      return <Quality />;
    case 'condition':
      return <Condition />;
    case 'mainDwelling.gla':
    case 'mainDwelling.foundation':
    case 'mainDwelling.units':
    case 'mainDwelling.sections':
    case 'mainDwelling.propertyType':
    case 'bathAboveGrade':
    case 'bathBelowGrade':
    case 'basement':
      return <MainDwelling />;
    case 'adu':
    case 'attic':
    case 'barn':
    case 'fireplace':
    case 'garageCarport':
    case 'porchPatioDeck':
    case 'shed':
    case 'workshop':
      return <AdditionalStructure structureKey={adjType} standalone />;
    case 'pool':
      return <AdditionalStructure structureKey="poolSpa" standalone />;
    case 'functionalUtility':
      return <FunctionalDepreciation />;
    case 'externalObsolescence':
      return <ExternalDepreciation />;
    case 'manual':
      return <AdditionalStructure structureKey="manualCost" standalone />;

    // unrendered commentaries
    // case 'garage': // ambiguous from garageCarport row
    // case 'carport': // ambiguous from garageCarport row
    // case 'spa': no row for this

    // unhandled rows:
    // case 'spa': no row for this
    // case 'belowGradeANSI': // no commentary section
    // case 'bonusRoom': // no commentary section
    // case 'manufactured': // no commentary section

    default:
      return null;
  }
};
